export default __webpack_public_path__ + "static/bmw-3-2b0fc67310fe2812851d7f86bc392063.jpg";